import React from 'react';
import { motion } from 'framer-motion';
import { TESTIMONIALS } from '@/lib/data';
import { Quote } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
export function Testimonials() {
  return (
    <section className="py-24 bg-gray-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-brand-lime font-bold tracking-widest uppercase text-sm mb-4">Témoignages</h2>
            <h3 className="text-4xl md:text-5xl font-display font-bold text-brand-purple mb-8">Ils nous font confiance</h3>
          </motion.div>
        </div>
        <div className="grid lg:grid-cols-3 gap-8">
          {TESTIMONIALS.map((testimonial, i) => (
            <motion.div
              key={testimonial.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="bg-white p-8 rounded-3xl shadow-sm border border-gray-100 flex flex-col relative"
            >
              <div className="absolute top-6 right-8 text-brand-lime/20">
                <Quote className="w-12 h-12 fill-current" />
              </div>
              <p className="text-brand-purple/70 text-lg italic leading-relaxed mb-8 flex-grow relative z-10">
                "{testimonial.content}"
              </p>
              <div className="flex items-center gap-4">
                <Avatar className="h-12 w-12 border-2 border-brand-lime/20">
                  <AvatarImage src={testimonial.avatar} alt={testimonial.author} />
                  <AvatarFallback>{testimonial.author.charAt(0)}</AvatarFallback>
                </Avatar>
                <div>
                  <div className="font-bold text-brand-purple">{testimonial.author}</div>
                  <div className="text-sm text-brand-purple/50">{testimonial.role}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}